<template>
    <!--     *********    CONTACT US 1     *********      -->
        <div class="contactus-1 section-image" v-lazy:background-image="'img/20180717_081223.jpg'"  id="contact">
            <div class="container">
                <div class="row">
                    <div class="col-md-5">
                        <h2 class="title">Get in Touch</h2>
                        <h4 class="description">We’d love to hear from you. If you're not sure what you need, don't worry - that's why we're here.</h4>
                        <info-section type="primary"
                                      icon="now-ui-icons location_pin">
                            <h4 class="info-title">Find us at the office</h4>
                            <p class="description"> 1443 Rock Spring Road
                                <br> Suite 114
                                <br> Bel Air, MD 21014
                            </p>
                        </info-section>

                        <info-section type="primary"
                                      icon="now-ui-icons tech_mobile">
                            <h4 class="info-title">Give us a ring</h4>
                            <p class="description"> Call: (410) 692 0692
                                <br> Fax: (410) 879 4990
                            </p>
                        </info-section>
                        <!-- <info-section type="primary" icon="now-ui-icons ui-1_email-85"> -->
                            <info-section type="primary" icon="now-ui-icons ui-1_send">
                            <h4 class="info-title">info<code style="color:white;">@</code>electronic<!-- -->tech<!-- -->corp<!-- -->&#46;<!-- -->c<!-- -->o<!-- -->m</h4>
                        </info-section>
                    </div>
                    <div class="col-md-5 ml-auto mr-auto">
                        <card type="contact" raised header-classes="text-center">
                            <h4 slot="header" class="card-title">Contact Us</h4>

                            <form role="form" id="contact-form" method="post">
                                <div class="row" >
                                    <div class="col-md-6 pr-2">
                                        <label>Name</label>
                                        <p class="error-messages" v-if="errors.first('name')">{{ errors.first('name') }}</p>
                                        <fg-input v-model="name" v-validate="'required'" type="text" name="name" placeholder="Name..."
                                                addon-left-icon="now-ui-icons users_circle-08" autocomplete="on">
                                        </fg-input>
                                        
                                    </div>
                                    <div class="col-md-6 pl-2">
                                        <label>Company</label>
                                        <fg-input v-model="company" type="text"  name="company" placeholder="Company..."
                                                addon-left-icon="now-ui-icons location_pin" autocomplete="on"> 
                                        </fg-input>
                                    </div>
                                </div>
                                <div class="form-group">
                                    <label>Email address</label>
                                    <p class="error-messages" v-if="errors.first('email')">{{ errors.first('email') }}</p>
                                    <fg-input v-model="email" v-validate="'required|email'" type="text" name="email" placeholder="Email..."
                                            addon-left-icon="now-ui-icons ui-1_email-85" autocomplete="on">
                                    </fg-input>
                                    
                                </div>
                                <div class="form-group">
                                    <label>Phone Number</label>
                                    <p class="error-messages" v-if="errors.first('phone')">{{ errors.first('phone') }}</p>
                                    <fg-input v-model="phone" type="text" name="phone" placeholder="Phone..."
                                            addon-left-icon="now-ui-icons tech_mobile" autocomplete="on">
                                    </fg-input>
                                    
                                </div>
                                <div class="form-group">
                                    <label>Your message</label>
                                    <p class="error-messages" v-if="errors.first('message')">{{ errors.first('message') }}</p>
                                    <textarea v-model="message" v-validate="'required'" type="text" name="message" class="form-control" id="message" rows="6"></textarea>
                                    
                                </div>
                                <div class="row">
                                    <div class="col-md-12">
                                        <!-- <n-checkbox>
                                            I'm not a robot
                                        </n-checkbox> -->
                                        <!-- <div class="g-recaptcha" data-sitekey="6Ldk6m8UAAAAAEkhTHum2aMgEgEQhGqh0F_ThNaC"></div> -->
                                        <div id="recap_element" class="g-recaptcha"></div>
                                    </div>
                                    
                                    <div class="col-lg-5">
                                        <n-button type="primary" round :class="{'btn-success no-click' : buttontext == 'Message Sent'}" @click.native="subCon()">{{buttontext}}</n-button>
                                    </div>
                                    <div class="col-lg-7">
                                        <p style="margin-top: 1rem;margin-bottom: 0px;color:red;font-weight:bold;" :class="{'font-success': response2 == 'Message Sent'}" v-if="response2 != ''">{{response2}}</p>
                                    </div>
                                    
                                    
                                </div>
                            </form>
                        </card>
                    </div>
                </div>
            </div>
        </div>
        
        <!--     *********    END CONTACT US 1      *********      -->
</template>
<script>
  import { Card, InfoSection, Button, Checkbox, FormGroupInput } from '@/components';
  import { Tooltip } from 'element-ui'

  export default {
    name: 'presentation',
    bodyClass: 'presentation-page',
    components: {
        Card,
        InfoSection,
      [Button.name]: Button,
      [Checkbox.name]: Checkbox,
      [FormGroupInput.name]: FormGroupInput,
      [Tooltip.name]: Tooltip,
    },
    data () {
        return {
            name: "",
            company: "",
            email: "",
            phone: "",
            message: '',
            response2: '',
            domain: 'https://api.website.gamsplus.systems',
            it: 'xi1133ltsQQ$$$$$$$trss3ee444.0!%6bb,<?>:"Ss',
            captchaResponse: '',
            buttontext: 'Send Message'
        }
    },
    mounted() {
        setTimeout(() => {
            grecaptcha.render('recap_element', {
            'sitekey' : '6Ldk6m8UAAAAAEkhTHum2aMgEgEQhGqh0F_ThNaC'
            });
        }, 1000);
        
    },
    methods: {
        
        subCon() {
            this.$validator.validate().then(result => {
                if (!result) {
                    // do stuff if not valid.
                    // console.log('not valid')
                } else {
                    // console.log('valid')
                    // var captcha = document.querySelector('#g-recaptcha-response').value;
                    var captcha = grecaptcha.getResponse()
                    this.$http.post(this.domain+'/contactform',{
                            'name':this.name, 'company':this.company, 'email': this.email, 'phone': this.phone, 'message': this.message, 'captcha': captcha, 'key': this.it, 'page': window.location.href
                        },{
                        headers: {
                            'content-type' : 'application/json'
                        }
                    }).then(function(data){
                        // console.log(data.body.msg)
                        
                        if(data.body.msg == 'Message Sent'){
                            this.name = ''
                            this.company = ''
                            this.email = ''
                            this.phone = ''
                            this.message = ''
                            grecaptcha.reset();
                            
                            this.buttontext = 'Message Sent'
                            this.gConversion()
                            this.errors.clear()
                            setTimeout(() => {
                                this.errors.clear()
                            }, 100);
                            setTimeout(() => {
                                this.errors.clear()
                            }, 200);
                            setTimeout(() => {
                                this.errors.clear()
                            }, 300);
                            setTimeout(() => {
                                this.errors.clear()
                            }, 400);
                            setTimeout(() => {
                                this.errors.clear()
                            }, 500);
                            setTimeout(() => {
                                this.buttontext = 'Send Message'
                            }, 5000);
                        } else {
                            this.response2 = data.body.msg
                        }
                        
                    })
                }
            });
                
        },
        gConversion(){
            this.$ga.event('Contact', 'Submit', 'Form', 1)
        }
    }
  }
</script>
<style>
.contactus-1 .card-contact {
    margin-top: 30px;
    min-width: 340px;
    overflow: hidden;
}
@media screen and (max-width: 410px){
    .contactus-1 .card-contact {
        min-width: auto;
        overflow: hidden;
    }
}
.contactus-1 label {
    margin-bottom: 15px;
}
.error-messages{
    position: absolute;
    color: red;
    font-size: 12px;
    margin-top: -16px;
    margin-left: 16px;
}
.font-success {
    color: #18ce0f !important;
}
.no-click {
    pointer-events: none;
}
</style>
